import LpaAgreementsForm from './LpaAgreementsForm';

export default LpaAgreementsForm;
